import { MaiFeedbackReason } from '~/lib/types/mai/MaiFeedbackReason';

import { MAI_FEEDBACK_REASON_OPTIONS } from './maiFeedback.constants';

const isMaiFeedbackReason = (value: string): value is MaiFeedbackReason =>
  MAI_FEEDBACK_REASON_OPTIONS.some((option) => option.value === value);

// DropdownV2 hands back `string | undefined`; narrow it against the options we
// rendered so an unexpected value can never reach the API as a reason.
export const toMaiFeedbackReason = (
  value: string | undefined,
): MaiFeedbackReason | null =>
  value !== undefined && isMaiFeedbackReason(value) ? value : null;
